import React, { useContext, useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import { ThemeContext } from '../../context/ThemeContext';

export const profitLoss = new Map();

export const SetPLValue = (id, value) => {
  profitLoss.set(id, value);
}

export const deletePLValue = (id) => {
  profitLoss.delete(id);
}

function AccountFooter({ }) {
  const { t } = useTranslation()
  const { accountSummary = [] } = useSelector(state => state.accountSummary, shallowEqual)
  const { updatePL } = useSelector((state) => state.profitLoss);
  const [floatingPL, setFloatingPL] = useState(0)
  const {darkMode} = useContext(ThemeContext)


  const calculatedEquity = accountSummary.balance ? (parseFloat(accountSummary.balance) + parseFloat(floatingPL))?.toFixed(2) : 0;
  const calculatedMarginLevel = calculatedEquity && accountSummary.usedMargin ? ((parseFloat(calculatedEquity) / parseFloat(accountSummary.usedMargin)) * 100)?.toFixed(2) : 0;
  const freeMargin = calculatedEquity ? parseFloat(calculatedEquity - accountSummary.usedMargin).toFixed(2) : 0;

  useEffect(() => {
    let pl = 0;
    if ([...profitLoss].length <= 0) {
      setFloatingPL(0);
      return;
    }
    [...profitLoss].map(item => {
      pl += parseFloat(item[1]) || 0
    })
    setFloatingPL(pl)
  }, [updatePL])

  return (
    // <div>
    //   <Grid container alignItems="center" justifyContent="space-between" style={{ height: '100%', }}>
    //     <Grid item style={{ display: 'flex' }} pl={1} gap={2} className="td-ellipsis">
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('balance')}: {(accountSummary.balance || 0).toFixed(2)} </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('credit')}: {(accountSummary.credit || 0).toFixed(2)}  </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('floatingPL')}: {floatingPL.toFixed(2)} </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('equity')}: {calculatedEquity} </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('usedMargin')}:  {(accountSummary.usedMargin || 0).toFixed(2)} </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('freeMargin')}: {freeMargin || "0.00"} </Typography>
    //       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('MarginLevel')}: {calculatedMarginLevel}%  </Typography>
    //     </Grid>
    //   </Grid>
    // </div>
    <div className='flex h-full items-center px-3' style={{backgroundColor: darkMode ? "#151924" : "#fff", color:darkMode? 'var(--lightText)':'var(--darkText)'}}>
      <div className='text-sm mx-2 ms-12 '>{t('balance')}: {(accountSummary?.balance || 0).toFixed(2)}</div>
      <div className='text-sm mx-2'>{t('credit')}: {(accountSummary?.credit || 0).toFixed(2)}</div>
      <div className='text-sm mx-2'>{t('floatingPL')}: {floatingPL.toFixed(2)}</div>
      <div className='text-sm mx-2'>{t('equity')}: {calculatedEquity}</div>
      <div className='text-sm mx-2'>{t('usedMargin')}: {(accountSummary?.usedMargin || 0).toFixed(2)}</div>
      <div className='text-sm mx-2'>{t('freeMargin')}: {freeMargin || 0.00}</div>
      <div className='text-sm mx-2'>{t('marginLevel')}: {calculatedMarginLevel}%</div>
    </div>
  );
}

export default AccountFooter;
